import React from 'react';
import PropTypes from 'prop-types';

import { useFormState } from 'react-use-form-state';

import { Input, Form, FormGroup, FormFeedback } from 'reactstrap';
import { Button } from '@shoflo/polymer/components/Button/Button';
import { getFSObjectType, getFSObjectName } from './fsObjectUtils';

import styled from 'styled-components';

import ConfirmDeleteWarning from 'components/ConfirmDeleteWarning';

const ContentWrapper = styled.label`
  color: #333;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 8px;
`;

const DeleteFSObjectForm = ({ fsObject, onSubmit, onCancel }) => {
  const [formState, { text }] = useFormState({
    title: '',
  });

  const { validity } = formState;

  const kind = getFSObjectType(fsObject);
  const fsObjectName = getFSObjectName(fsObject);

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(fsObject._id);
      }}
    >
      <ContentWrapper>
        You are about to delete the <strong>{fsObjectName}</strong> {kind}. This
        action cannot be undone! All content within this {kind} will be
        permanently deleted from Shoflo. Any crew member or team admin who had
        access to this {kind} will no longer be able to access it.
      </ContentWrapper>

      <FormGroup>
        <ConfirmDeleteWarning
          id="fsObjectTitleLabel"
          htmlFor="fsObjectTitle"
          deleteObjectTitle={fsObjectName}
        />

        <Input
          id="fsObjectTitle"
          aria-labelledby="fsObjectTitleLabel"
          placeholder="e.g. Documents"
          {...text({
            name: 'title',
            validate: (v) => {
              return v === fsObject.name;
            },
            touchOnChange: true,
          })}
          invalid={formState.touched.name && !formState.validity.title}
          required
        />
        {validity.title === false && (
          <FormFeedback> Names must match.</FormFeedback>
        )}
      </FormGroup>
      <div className="float-end modal-footer">
        <Button color="danger" disabled={!formState.validity.title}>
          Delete
        </Button>{' '}
        <Button
          color="secondary"
          variant="outlined"
          onClick={(e) => {
            e.preventDefault();
            onCancel();
          }}
        >
          Cancel
        </Button>
      </div>
    </Form>
  );
};

DeleteFSObjectForm.propTypes = {
  fsObject: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default DeleteFSObjectForm;
